
import React, {Component} from 'react';
import PropTypes from 'prop-types';

export const detailConfig = {
        1:"detailPicture",
        2:"detailVideo",
        3:"detailOtherFile",
        4:"detailAudio",
};
